import { render, staticRenderFns } from "./MetricsView.vue?vue&type=template&id=62c52b00&scoped=true&"
import script from "./MetricsView.vue?vue&type=script&lang=js&"
export * from "./MetricsView.vue?vue&type=script&lang=js&"
import style0 from "./MetricsView.vue?vue&type=style&index=0&id=62c52b00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c52b00",
  null
  
)

export default component.exports